<template>
    <div class="loader-container">
        <div class="loader">
        </div>
    </div>

</template>

<script>
    export default {
        name: "UniCircularLoader"
    }
</script>

<style scoped lang="scss">
    .loader-container {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .loader {
        -webkit-animation: spin 1s linear infinite;
        animation: spin 1s cubic-bezier(.23, .81, .69, .4) infinite;
        border: 2px solid var(--color-grey-light-2);
        border-top: 2px solid var(--color-primary);
        border-radius: 50%;
        height: 36px;
        width: 36px;
    }

    @keyframes spin {
        to {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }


    body {
        background-color: #f1f2f3;
    }
</style>
